import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.metadata', [
]);

const MetadataFactory = (API_URL, $http) => {

    const Metadata = {};

    Metadata.getPlaceMetadata = (placeId, filterParams) => {
      const url = `${API_URL}metadata/place/${placeId}?placeId`;
      return $http.post(url, { filterParams }).then(resp => resp.data);
    }
    
    Metadata.getPlaceMetadataFields = (placeId) => {
      const url = `${API_URL}metadata/place/${placeId}/fields?placeId`;
      return $http.get(url).then(resp => resp.data);
    }

    Metadata.getMetadataData = (filterParams) => {
      const url = `${API_URL}metadata/data`;
      return $http.post(url, { filterParams }).then(resp => resp.data);
    }

    Metadata.getMetadataFields = () => {
      const url = `${API_URL}metadata/fields`;
      return $http.get(url).then(resp => resp.data);
    }

    return Metadata;
  };

  module.export = module.factory('Metadata', MetadataFactory);


